export const removeSpacesFromVerificationCode = (verificationCode: string) => verificationCode.replace(/\s/g, "");
